import axiosWithoutInterceptor from "../../axiosWithoutInterceptor";
import { buildApiV3Url } from "../../shared/Utils";
import type {
    DataTransferDownloadResponse,
    DataTransferExportRequest,
    DataTransferFileId,
    DataTransferImportFileRef,
    DataTransferImportManifest,
    DataTransferImportRequest,
} from "./types";

export const postDataTransferExport = async (request: DataTransferExportRequest): Promise<void> => {
    await axiosWithoutInterceptor.post(buildApiV3Url("data-transfers/export"), request, {
        withCredentials: true,
    });
};

/**
 * Ask the service to read the uploaded `.avlr` package's manifest and return its companies, so the
 * user can map them. The browser cannot open the zip in S3 itself.
 */
export const postDataTransferImportPrepare = async (
    file: DataTransferImportFileRef
): Promise<DataTransferImportManifest> => {
    const response = await axiosWithoutInterceptor.post<DataTransferImportManifest>(
        buildApiV3Url("data-transfers/import/prepare"),
        file,
        { withCredentials: true }
    );
    return response.data;
};

export const postDataTransferImport = async (request: DataTransferImportRequest): Promise<void> => {
    await axiosWithoutInterceptor.post(buildApiV3Url("data-transfers/import"), request, {
        withCredentials: true,
    });
};

/**
 * Resolve a presigned S3 URL for a job's package (`.avlr`) or log file. The caller opens the
 * returned URL to start the download — the URL is short-lived, so it is fetched on click rather
 * than rendered into the grid.
 */
export const getDataTransferDownloadUrl = async (
    id: number,
    fileId: DataTransferFileId
): Promise<string> => {
    const response = await axiosWithoutInterceptor.get<DataTransferDownloadResponse>(
        buildApiV3Url(`data-transfers/${id}/files/${fileId}/$download`),
        { withCredentials: true }
    );
    return response.data.downloadUrl;
};
